const semanticClassNames = {
  root: 'text-art',
} as const;

export default semanticClassNames;
